import { PublicClientApplication } from "@azure/msal-browser";

const clientId =
  process.env.VUE_APP_MICROSOFT_CLIENT_ID ||
  process.env.VITE_MICROSOFT_CLIENT_ID ||
  "microsoft-client-id-not-configured";
const tenantId =
  process.env.VUE_APP_MICROSOFT_TENANT_ID ||
  process.env.VITE_MICROSOFT_TENANT_ID ||
  "common";

const authorityMetadata = {
  authorization_endpoint: `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize`,
  token_endpoint: `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/token`,
  end_session_endpoint: `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/logout`,
  issuer: `https://login.microsoftonline.com/${tenantId}/v2.0`,
  jwks_uri: `https://login.microsoftonline.com/${tenantId}/discovery/v2.0/keys`,
};

const microsoftInstance = new PublicClientApplication({
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri:
      process.env.VUE_APP_MICROSOFT_REDIRECT_URI ||
      process.env.VITE_MICROSOFT_REDIRECT_URI ||
      window.location.origin,
    authorityMetadata: JSON.stringify(authorityMetadata),
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
});

let microsoftInitializationPromise;

export const initializeMicrosoft = () => {
  if (!microsoftInitializationPromise) {
    microsoftInitializationPromise = microsoftInstance.initialize();
  }
  return microsoftInitializationPromise;
};

export const microsoftConfigured = clientId !== "microsoft-client-id-not-configured";

export const microsoftLoginRequest = {
  scopes: ["openid", "profile", "email", "User.Read"],
  prompt: "select_account",
};

export default microsoftInstance;